import * as actionTypes from "./actionTypes";
import axios from "axios";
import { baseUrlDashboard } from "../../assets/shared/urlApps";
import { buildBearerToken, storageEmpresaId } from "../../assets/shared/sessionData";
import idIndicadores from "../../assets/shared/idIndicadores";
import { enqueueSnackbar } from "./snackbar";

/** Reintentos de loadMonedas si la API no responde bien. */
const MAXIMO_REINTENTOS_MONEDAS = 3;

export const seleccionarMoneda = (idMoneda, idEmpresa = storageEmpresaId()) => {
  return (dispatch) => {
    dispatch(executeCambiarMoneda(true));
    const authStr = "Bearer ".concat(sessionStorage.getItem("token"));
    const baseUrl = baseUrlDashboard();

    axios
      .get(
        `${baseUrl}monedas/cambiarMoneda?monedaId=${idMoneda}&empresaId=${idEmpresa}&indicadorId=${idIndicadores.cambiarMoneda}`,
        {
          headers: {
            Authorization: authStr,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        dispatch(executeCambiarMoneda(false));
        dispatch(
          enqueueSnackbar({
            message: "No se pudo cambiar la moneda.",
            options: {
              variant: "error",
            },
          })
        );
      });
  };
};

const executeCambiarMoneda = (loadingCambiarMoneda) => {
  return {
    type: actionTypes.EXECUTE_CAMBIAR_MONEDA,
    loadingCambiarMoneda,
  };
};

export const loadMonedas = (idEmpresa = storageEmpresaId(), reintento = 0) => {
  return (dispatch) => {
    dispatch(loadMonedasStart());

    const authStr = buildBearerToken();

    axios
      .get(
        `${baseUrlDashboard()}monedas/monedas?idEmpresa=${idEmpresa}&indicadorId=${
          idIndicadores.monedas
        }`,
        {
          headers: {
            Authorization: authStr,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        dispatch(loadMonedasSuccess(response.data));
      })
      .catch((error) => {
        if (error.response && error.response.status !== 500 && reintento < MAXIMO_REINTENTOS_MONEDAS) {
          dispatch(loadMonedas(idEmpresa, reintento + 1));
        } else {
          dispatch(loadMonedasFail(error));
        }
      });
  };
};

const loadMonedasStart = () => {
  return {
    type: actionTypes.LOAD_MONEDAS_START,
  };
};

const loadMonedasSuccess = (monedas) => {
  return {
    type: actionTypes.LOAD_MONEDAS_SUCCESS,
    monedas,
  };
};

const loadMonedasFail = (error) => {
  return {
    type: actionTypes.LOAD_MONEDAS_FAIL,
    error,
  };
};
